import angular from 'angular';

import PoiTypeListModalComponent from './poi-type-list-modal.component';

const PoiTypeListModalModule = angular
    .module('control-room.poi.components.poi-type-list.components.poi-type-list-modal', [])
    .component('crPoiTypeListModal', PoiTypeListModalComponent);

export default PoiTypeListModalModule;
